import { gql } from 'apollo-boost';


export const RESOURCE_FILE_QUERY = gql`
query resourceFile($resourceId: UUID!, $resourceFileId:UUID!){
    resourceFile(resourceID: $resourceId, resourceFileID: $resourceFileId) {
      node {
        id
        genericFile
      }
    }
  }`;